define('models/ServiceLine',[
	'core/can',
	'moment'
], function(can, moment) {
	
	var Disciplines = {
			'RN':  { RevenueCode: '0551', Description: 'Registered Nurse' },
			'LPN': { RevenueCode: '0551', Description: 'Licensed Practical Nurse' },
			'SN':  { RevenueCode: '0551', Description: 'Skilled Nursing' },
			'HHA': { RevenueCode: '0571', Description: 'Home Health Aide' },
			'PT':  { RevenueCode: '0421', Description: 'Physical Therapy' },
			'PTA': { RevenueCode: '0421', Description: 'Physical Therapy Assistant' },
			'OT':  { RevenueCode: '0431', Description: 'Occupational Therapy' },
			'OTA': { RevenueCode: '0431', Description: 'Occupational Therapy Assistant' },
			'ST':  { RevenueCode: '0441', Description: 'Speech Therapy' },
			'MSW': { RevenueCode: '0561', Description: 'Medical Social Worker' }
		},
		HCPCS = {
			'G0154': { Discipline: 'SN', Procedure: 'Direct Patient Care' },
			'G0162': { Discipline: 'SN', Procedure: 'Evaluation' }, // Manage
			'G0163': { Discipline: 'SN', Procedure: 'Assessment' }, // Observation
			'G0164': { Discipline: 'SN', Procedure: 'Training' }, // Teaching
			'G0156': { Discipline: 'HHA', Procedure: 'Visit' },
			'G0159': { Discipline: 'PT', Procedure: 'Evaluation' }, // Re-Evaluation / Management
			'G0151': { Discipline: 'PT', Procedure: 'Routine Visit' },
			'G0157': { Discipline: 'PTA', Procedure: 'Routine Visit' },
			'G0160': { Discipline: 'OT', Procedure: 'Evaluation' }, // Re-Evaluation
			'G0152': { Discipline: 'OT', Procedure: 'Routine Visit' },
			'G0158': { Discipline: 'OT', Procedure: 'Routine Visit' },
			'G0161': { Discipline: 'ST', Procedure: 'Evaluation' }, // Re-Evaluation
			'G0153': { Discipline: 'ST', Procedure: 'Routine Visit' },
			'G0155': { Discipline: 'MSW', Procedure: 'Visit' }, // Evaluation / Regular Visit
			
			// New codes for 2016
			'G0299': { Discipline: 'RN', Procedure: 'Direct Patient Care' },
			'G0300': { Discipline: 'LPN', Procedure: 'Direct Patient Care' },
			
			// New codes for 2017
			'G0493': { Discipline: 'RN', Procedure: 'Observation and Assessment' },
			'G0494': { Discipline: 'LPN', Procedure: 'Observation and Assessment' },
			'G0495': { Discipline: 'RN', Procedure: 'Training and/or Education' },
			'G0496': { Discipline: 'LPN', Procedure: 'Training and/or Education' },
			// New codes for 2020
			'G2168': { Discipline: 'PT', Procedure: 'Physical Therapist Assistance Routine Visit' },
			'G2169': { Discipline: 'OT', Procedure: 'Occupational Therapist Assistance Routine Visit' },
		}

	return can.Model.extend({
		
		getRevenueCodeByHCPCS: function(code) {
			if (code) {
				var o = HCPCS[code.toUpperCase()];
				return o ? Disciplines[o.Discipline].RevenueCode : undefined;
			} else {
				return undefined;
			}
		},
		
		getDescriptionByHCPCS: function(code, longer) {
			if (code) {
				var o = HCPCS[code.toUpperCase()];
				return o ? (longer ? Disciplines[o.Discipline].Description : o.Discipline) + ' ' + o.Procedure : undefined;
			} else {
				return undefined;
			}
		}

		
	},{
		
		define: {
			Charges: {
				type: 'number',
				value: 0
			},
			NonCoveredCharges: {
				type: 'number',
				value: 0
			},
			Units: {
				type: 'number',
				value: 0
			},
			CoveredUnits: {
				type: 'number',
				value: 0
			},
			Modifier: {
				type: 'string',
			}	
		},


		// Some HCPCS codes change from year to year
		// Use this to validate the codes and serviceDate entered by the user
		// params:
		//	options: {
		//		newYear: date string or moment of the year being checked
		// 		serviceDate: date string or moment of the service date entered by the user
		// 		hcpcsCode: string of the hcpcsCode entered by the user
		//  	oldCodes: array of strings for the oldYears codes
		//  	newCodes: array of strings for the newYears codes
		//  }
		// returns:
		//	boolean: if the hcpcs code is valid for the serviceDate provided return 
		isValidHcpcsCodeForServiceDate: function(options) {
			var mNewYear = moment.utc(new Date(options.newYear)),
				mServiceDate = moment.utc(options.serviceDate),
				serviceDateIsBeforeNewYear = mServiceDate.isBefore(mNewYear),
				isOldCode = options.oldCodes.includes(options.hcpcsCode),
				isNewCode = options.newCodes.includes(options.hcpcsCode);
			
			// If hcpcsCode is not in either list don't validate 
			if(!isOldCode && !isNewCode) {
				return true;
			}

			// Service date is before newYear and HCPCS code is old code || Service date is after newYear and HCPCS code is new code
			if( (serviceDateIsBeforeNewYear && isOldCode) || (!serviceDateIsBeforeNewYear && !isOldCode) ) {
				return true;
			}
			else {
				return false;
			}
		},

		// I am not proud of this nasty string voodoo -Keith
		// Helper to create an error message based on the users input
		// params:
		//	options: {
		//		newYear: date string or moment of the year being checked
		// 		serviceDate: date string or moment of the service date entered by the user
		//  	oldCodes: array of strings for the oldYears codes
		//  	newCodes: array of strings for the newYears codes
		//  }
		// returns:
		//	boolean: if the hcpcs code is valid for the serviceDate provided return 
		createServiceLineWarning: function(options) {
			var mNewYear = moment.utc(new Date(options.newYear)),
				mServiceDate = moment.utc(options.serviceDate),
				serviceDateIsBeforeNewYear = mServiceDate.isBefore(mNewYear),
				codeString = serviceDateIsBeforeNewYear ?  options.oldCodes.join(" / ") : options.newCodes.join(" / "),
				isBeforeString = serviceDateIsBeforeNewYear ? 'before ' : 'after ';

			return 'Service date is ' + isBeforeString + mNewYear.format('MMMM Do YYYY') + '. ' +
					'Use ' + codeString;
		},

		
		
		_Description: can.compute(function() {
			var desc;
			
			desc = this.attr('Description');
			if (desc) return desc;
			
			switch (this.attr('RevenueCode')) {
				case '0023': return 'HIPPS Code';
				case '0270':
				case '0272': return 'Non-Routine Supplies';
				case '0623': return 'Wound Care Supplies';
			}
			
			desc = this.constructor.getDescriptionByHCPCS(this.attr('HcpcsCode'), true);
			if (desc) return desc;
				
			if (this.attr('_isQ')) return 'Location of Services Code';
		}),

		isValid2015To2016: can.compute(function() {
			var	options = {
					newYear: '01/01/2016',
		 			serviceDate: this.attr('ServiceDateFrom'),
		 			hcpcsCode: this.attr('HcpcsCode'),
		  			oldCodes: ['G0154'],
		  			newCodes: ['G0299', 'G0300'],
				};

			return this.isValidHcpcsCodeForServiceDate(options);
		}),

		isValid2016To2017: can.compute(function() {
			var	options = {
					newYear: '01/01/2017',
		 			serviceDate: this.attr('ServiceDateFrom'),
		 			hcpcsCode: this.attr('HcpcsCode'),
		  			oldCodes: ['G0163', 'G0164'],
		  			newCodes: ['G0493', 'G0494', 'G0495', 'G0496'],
				};

			return this.isValidHcpcsCodeForServiceDate(options);
		}),

		_serviceLineWarning: can.compute(function(newWarning, oldWarning) {
			var	hcpcsCode = this.attr('HcpcsCode'),
				serviceDate = this.attr('ServiceDateFrom'),
				isRevenue0551 = (this.attr('RevenueCode') === '0551'),
        		hasHcpcsCode = (hcpcsCode && hcpcsCode.length > 0),
				createWarningMessage = this.createServiceLineWarning;

			
			if(isRevenue0551 && hasHcpcsCode && serviceDate) {
				
				var isValid2015To2016 = this.attr('isValid2015To2016'),
					isValid2016To2017 = this.attr('isValid2016To2017');

				if(!isValid2015To2016) {
					var options = {
						newYear: '01/01/2016',
						serviceDate: serviceDate,
						oldCodes: ['G0154'],
						newCodes: ['G0299', 'G0300'],
					};

					return createWarningMessage(options);
				}

				if(!isValid2016To2017) {
					if( ['G0163', 'G0493', 'G0494'].includes(hcpcsCode) ) {
						var options = {
							newYear: '01/01/2017',
							serviceDate: serviceDate,
							oldCodes: ['G0163'],
							newCodes: ['G0493', 'G0494'],
						};
						
						return createWarningMessage(options);
					}

					if( ['G0164', 'G0495', 'G0496'].includes(hcpcsCode) ) {
						var options = {
							newYear: '01/01/2017',
							serviceDate: serviceDate,
							oldCodes: ['G0164'],
							newCodes: ['G0495', 'G0496'],
						};

						return createWarningMessage(options);
					}
				}
			}

			return '';
		}),

		_isIncorrectHcpcs: can.compute(function() {
			var	hcpcsCode = this.attr('HcpcsCode'),
				serviceDate = this.attr('ServiceDateFrom'),
				isRevenue0551 = (this.attr('RevenueCode') === '0551'),
        		hasHcpcsCode = (hcpcsCode && hcpcsCode.length > 0);

			if(isRevenue0551 && hasHcpcsCode && serviceDate) {
				var isValid2015To2016 = this.attr('isValid2015To2016'),
					isValid2016To2017 = this.attr('isValid2016To2017');

				return !isValid2015To2016 || !isValid2016To2017;
			}

			return false;
        }),
		
		_isHIPPS: can.compute(function() {
			var hcpcs = this.attr('HcpcsCode');
			return !hcpcs ? undefined : hcpcs.match(/^[0-9]/) !== null;
		}),
		
		_isHCPCS: can.compute(function() {
			var hcpcs = this.attr('HcpcsCode');
			return !this.attr('_isHIPPS') && hcpcs && hcpcs.length>0;
		}),
		
		_isQ: can.compute(function() {
			var hcpcs = this.attr('HcpcsCode');
			return !hcpcs ? undefined : hcpcs.match(/^[Q]/i) !== null;
		}),
		
		_isProcedure: can.compute(function() {
			return this.attr('_isHCPCS') && !this.attr('_isQ');
		})
		
	});
			
	/**
	 * Requirements
	 * 
	 * with valid HCPCS Code, get all information
	 */
			

		
/*		
	'Non-Routine Supplies'
	0270 'All non-routine supplies except Wound Care supplies'
	0623 'Wound Care supplies'
	
	'Q5001' // Hospice or home health care provided in patient�s home/residence
	'Q5002' // Hospice or home health care provided in assisted living facility
	'Q5009' // Hospice or home health care provided in place not otherwise specified (NO)


	// Hospice
	Q5001 Care provided in patient's home/residence
	Q5002 Care provided in assisted living facility
	Q5003 Care provided in Nursing Long Term Care Facility (LTC) or Non-Skilled Nursing Facility (NF)
	Q5004 Care provided in Skilled Nursing Facility (SNF)
	Q5005 Care provided in Inpatient Hospital
	Q5006 Care provided in Inpatient Hospice Facility
	Q5007 Care provided in Long Term Care Hospital (LTCH)
	Q5008 Care provided in Inpatient Psychiatric Facility
	Q5009 Care provided in place not otherwise specified (NOS)
	Q5010 Care provided in Hospice Facility

*/

});
